import { useRef } from 'react';
import { getShouldUseModernComponent } from '~/growthbook';

export const useModernComponent = (feature: string) => {
  const flags = useRef<Record<string, boolean>>(getShouldUseModernComponent()).current;

  return flags[feature];
};
